<template>
  <div class="result-list-wrap">
    <a-row class="header-wrap">
      <a-col :span="16">
        <span class="pre-title">共<span class="total">{{paginationOpt.total}}</span>条专利</span>
        <div class="switch-icon-wrap" v-if="false">
          <span v-for="item in switchIcon" :key="item.key" :class="{switchIconActive:item.component === currentSwitchIconComponent}" :title="item.tips">
            <my-icon :type="item.type" @click="switchIconClick(item)"></my-icon>
          </span>
        </div>
        <ASelect class="selectItem" :instance="select1" @change="timingChange"></ASelect>
        <ASelect v-if="false" class="selectItem" :instance="select2" @change="familyMergeChange"></ASelect>
      </a-col>
      <a-col :span="8">
        <InputSearch class="inputSearch" placeholder="输入搜索内容" @inputChange="onSearch"></InputSearch>
      </a-col>
    </a-row>
    <component :is="currentSwitchIconComponent" :searchParams="assignParams" @updateTotal="setTotal"></component>
    <APagination ref="pagination" :paginationOpt="paginationOpt" @change="handlerPaginationChange"></APagination>
    <FamilyModal ref="familyModal" v-on="$listeners" :defaultValue="familySettingDefaultValue"></FamilyModal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import InputSearch from '@/components/InputSearch/index.vue'
import ASelect from '@/views/backstageSupport/components/formTable/components/ASelect'
import ListView from './components/ListView.vue'
import TextImgView from './components/TextImgView.vue'
import ImgView from './components/ImgView.vue'
import APagination from './components/pagination.vue'
import FamilyModal from './components/FamilyModal.vue'
import { select1, select2 } from './configs'

export default {
  props: {
    searchParams: Object,
    familySettingDefaultValue:Object
  },
  data() {
    return {
      select1,
      select2,
      familySetting:false,  // 同族合并弹窗
      currentSwitchIconComponent: 'ListView',
      switchIcon: [
        {
          type: 'icon-liebiaoshitu', key: 'liebiaoshitu', component: 'ListView', tips: '列表视图'
        },
        {
          type: 'icon-tuwenshitu', key: 'tuwenshitu', component: 'TextImgView', tips: '图文视图'
        },
        {
          type: 'icon-shoutushitu', key: 'shoutushitu', component: 'ImgView', tips: '首图视图'
        }
      ],
      // 最初的请求数据的分页参数，后续的变化，会通过pagination的组件抛出
      paginationOpt: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      assignParams:{},  // 把分页的参数融合进去
      searchExpression: '', // 检索
      // 弹窗默认值
      familySelect: 0,  // 记录上一次的选中值
    }
  },
  components: {
    ASelect,
    InputSearch,
    ListView,
    TextImgView,
    ImgView,
    APagination,
    FamilyModal
  },
  watch: {
    searchParams: {
      handler(nVal) {
        this.assignParams = {...this.assignParams, ...nVal}
      },
      deep:true
    },
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getFilterAndExcludeExp',
    ])
  },
  created() {
    this.assignParams = {...this.searchParams, ...this.paginationOpt}
    this.clearSecondSearchExp() // 重新进来会清空上一次输入的检索结果
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateSearchExp',
      'clearSecondSearchExp'
    ]),
    setTotal(total) {
      this.paginationOpt.total = total || 0
    },
    switchIconClick(item) {
      this.currentSwitchIconComponent = item.component
    },
    // 分页器参数变化，带动列表的数据变化
    handlerPaginationChange() {
      const paginationRef = this.$refs.pagination
      this.assignParams = {
        ...this.assignParams,
        page: paginationRef.currentPage || 1,
        pageSize: paginationRef.pageSize || 10
      }
      // console.log(paginationOpt, '分页变化参数')
    },
    // 清空
    clearSearchValue() {
      this.searchExpression = ''
    },
    // 时机变化
    timingChange(v) {
      this.$emit('timingChange', v)
    },
    // 更新检索式
    onSearch(v) {
      this.searchExpression = v
      const exp = v ? `SS=(${v})` : ''
      this.updateSearchExp(exp)
    },
    // 同族合并修改
    familyMergeChange(v) {
      this.select2.defaultValue = v
      if(v === 'set') {
        this.$refs.familyModal.handlerVisible(true, {
          source:'updateFamilySetting'
        })
        this.select2.defaultValue = this.familySelect
        return this.familySetting = true
      }
      this.familySelect = v
      this.$emit('familySelectChange', v)
    }
  }
}
</script>
